import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';

const AddClient = ({ show, onHide, setAuthUrl, setAddUserActive, authUrlData, setIsLoading }) => {
    const [formData, setFormData] = useState({
        client_id: '',
        project_id: '',
        auth_uri: '',
        token_uri: '',
        auth_provider_x509_cert_url: '',
        client_secret: '',
        redirect_uris: [''],

    });
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleRedirectChange = (index, value) => {
        const updatedRedirectUris = [...formData.redirect_uris];
        updatedRedirectUris[index] = value;
        setFormData({ ...formData, redirect_uris: updatedRedirectUris });
    };

    const addRedirectUri = () => {
        setFormData({
            ...formData,
            redirect_uris: [...formData.redirect_uris, ''],
        });
    };

    const removeRedirectUri = (index) => {
        const updatedRedirectUris = formData.redirect_uris.filter((_, i) => i !== index);
        setFormData({ ...formData, redirect_uris: updatedRedirectUris });
    };

    const handleSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }
        setValidated(true);
        setErrorMessage('');
        setSuccessMessage('');
        setIsLoading(true);
        try {
            const response = await services.email.CreateEmailUser(formData);
            const client_id = response?.data?.data?.client_id;
            setSuccessMessage('Credential created successfully!');
            const urlResponse = await services.email.updateAuthEmail(client_id);
            setAuthUrl(urlResponse?.data?.authUrl);
            setTimeout(() => {
                onHide();
                setAddUserActive(true);
            }, 1000);
        } catch (error) {
            toast.error(error?.response?.data?.error)
            setErrorMessage(error.response?.data?.message || 'Failed to create credential');
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (authUrlData && authUrlData.length > 0) {
            const firstItem = authUrlData[0];
            setFormData({
                client_id: firstItem.client_id || '',
                project_id: firstItem.project_id || '',
                auth_uri: firstItem.auth_uri || '',
                token_uri: firstItem.token_uri || '',
                auth_provider_x509_cert_url: firstItem.auth_provider_x509_cert_url || '',
                client_secret: firstItem.client_secret || '',
                redirect_uris: firstItem.redirect_uris || [''],
            });
        }
    }, [authUrlData]);
    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <div className="form-containerCreate container mt-4">
                <h2>Create Credential</h2>

                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group controlId="client_id" className="mb-3">
                        <Form.Label>Client ID</Form.Label>
                        <Form.Control
                            type="text"
                            name="client_id"
                            value={formData.client_id}
                            onChange={handleInputChange}
                            placeholder="Enter Client ID"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid Client ID.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="project_id" className="mb-3">
                        <Form.Label>Project ID</Form.Label>
                        <Form.Control
                            type="text"
                            name="project_id"
                            value={formData.project_id}
                            onChange={handleInputChange}
                            placeholder="Enter Project ID"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid Project ID.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="auth_uri" className="mb-3">
                        <Form.Label>Auth URI</Form.Label>
                        <Form.Control
                            type="url"
                            name="auth_uri"
                            value={formData.auth_uri}
                            onChange={handleInputChange}
                            placeholder="Enter Auth URI"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid Auth URI.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="token_uri" className="mb-3">
                        <Form.Label>Token URI</Form.Label>
                        <Form.Control
                            type="url"
                            name="token_uri"
                            value={formData.token_uri}
                            onChange={handleInputChange}
                            placeholder="Enter Token URI"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid Token URI.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="auth_provider_x509_cert_url" className="mb-3">
                        <Form.Label>Auth Provider X509 Cert URL</Form.Label>
                        <Form.Control
                            type="url"
                            name="auth_provider_x509_cert_url"
                            value={formData.auth_provider_x509_cert_url}
                            onChange={handleInputChange}
                            placeholder="Enter Auth Provider X509 Cert URL"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid Cert URL.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="client_secret" className="mb-3">
                        <Form.Label>Client Secret</Form.Label>
                        <Form.Control
                            type="text"
                            name="client_secret"
                            value={formData.client_secret}
                            onChange={handleInputChange}
                            placeholder="Enter Client Secret"
                            required
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Client Secret.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Label>Redirect URIs</Form.Label>
                    {formData.redirect_uris.map((uri, index) => (
                        <Row key={index} className="mb-3">
                            <Col>
                                <Form.Control
                                    type="url"
                                    value={uri}
                                    onChange={(e) => handleRedirectChange(index, e.target.value)}
                                    placeholder={`Redirect URI ${index + 1}`}
                                    required
                                    disabled
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid Redirect URI.
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    ))}

                </Form>
            </div>
        </Modal>
    );
};

export default AddClient;
